module.exports = __webpack_public_path__ + "static/media/lightbulb-dollar.851efa37.svg";